<!-- @format -->

<template>
	<div v-if="refresh">
		<div class="employee-container">
			<pcp-system-layout ref="layout" style="width: 99%">
				<template #west>
					<div v-if="showTree" :style="{ width: treeWidth + 'px' }" class="pc-employee-selector-tree">
						<div class="layout-header-tools">
							<el-tooltip :hide-after="500" :content="isExpand ? '收起' : '展开'" placement="top">
								<el-link :underline="false" class="pin-btn" @click="handleExpandCollapse">
									<i class="ibps-icon ibps-icon-pack-up-admin-icon" />
								</el-link>
							</el-tooltip>
						</div>
						<div v-if="isExpand" ref="searchForms" class="pc-tree-search-form">
							<el-form :status-icon="false">
								<el-form-item label-width="0">
									<el-select
										v-model="partyType"
										:disabled="currentOrgIdValue === '' ? false : $store.getters.isSuper ? false : !isUseScope"
										placeholder="请选择"
										@change="changePartyType"
									>
										<el-option
											v-for="option in partyTypeOptions"
											:key="option.value"
											:value="option.value"
											:label="option.label"
										/>
									</el-select>
								</el-form-item>
							</el-form>
							<!-- <el-checkbox v-model="inclueChild" :disabled="partyType==='role'||partyType==='group'" style="margin:5px 0 0 5px;">包含子项</el-checkbox> -->
							<!-- 重置 -->
						</div>
						<div v-if="toolbars && isExpand" ref="toolbar" class="pc-tree-toolbar">
							<el-dropdown size="default">
								<el-button
									:class="['layout-header--' + 'large']"
									icon="MoreFilled"
									size="small"
									style="border-radius: 5px"
								/>
								<template #dropdown>
									<el-dropdown-menu>
										<pc-toolbar :actions="toolbars" :type="'menu'" @action-event="handleTreeAction" />
									</el-dropdown-menu>
								</template>
							</el-dropdown>
						</div>
						<div v-show="isExpand" :style="{ height: '500px' }">
							<el-scrollbar style="height: 100%; width: 100%" wrap-class="pc-tree-wrapper ibps-scrollbar-wrapper">
								<el-tree
									v-if="(!isUseScope || !hiddenTree) && !defaultExpandAll"
									ref="elTree"
									v-loading="loadingTree"
									:data="treeData"
									:expand-on-click-node="false"
									:props="{ children: 'children', label: 'name', isLeaf: 'leaf' }"
									:default-expanded-keys="defaultExpandedKeys"
									:default-expand-all="defaultExpandAll"
									:load="
										lazyTree
											? partyType === 'org' && partyTypeId === '3'
												? loadOrgTreeNode3
												: partyType === 'position'
												? partyTypeId === '3'
													? loadPosTreeNode3
													: loadPosTreeNode
												: loadOrgTreeNode
											: null
									"
									:lazy="lazyTree"
									node-key="id"
									pid-key="parentId"
									highlight-current
									@node-click="handleNodeClick"
								>
									<template #default="{ node }">
										<span class="ibps-custom-tree-node" style="width: 100%">
											<el-tooltip
												class="item"
												effect="dark"
												:enterable="false"
												:content="node.label"
												placement="top"
												:disabled="nodeWidth(node) >= stringWidth(node)"
											>
												<span> {{ node.label }} </span>
											</el-tooltip>
										</span>
									</template>
								</el-tree>
								<el-tree
									v-if="defaultExpandAll"
									ref="elTree"
									v-loading="loadingTree"
									:data="treeData"
									:expand-on-click-node="false"
									:props="{ children: 'children', label: 'name', isLeaf: 'leaf' }"
									:default-expanded-keys="defaultExpandedKeys"
									:default-expand-all="true"
									node-key="id"
									pid-key="parentId"
									highlight-current
									@node-click="handleNodeClick"
								>
									<template #default="{ node }">
										<span class="ibps-custom-tree-node" style="width: 100%">
											<el-tooltip
												class="item"
												effect="dark"
												:enterable="false"
												:content="node.label"
												placement="top"
												:disabled="nodeWidth(node) >= stringWidth(node)"
											>
												<span> {{ node.label }} </span>
											</el-tooltip>
										</span>
									</template>
								</el-tree>
							</el-scrollbar>
						</div>
					</div>
				</template>

				<pc-crud
					ref="crud"
					:height="tableHeight"
					:data="listData"
					:toolbars="listConfig.toolbars"
					:pk-key="pkKey"
					:search-form="listConfig.searchForm"
					:columns="listConfig.columns"
					:pagination="pagination"
					:loading="loading"
					:selection-type="multiple ? 'checkbox' : 'radio'"
					@selection-change="handleSelectionChange"
					@action-event="handleAction"
					@sort-change="handleSortChange"
					@pagination-change="handlePaginationChange"
				/>
				<!-- <more-search
        :title="title"
        :visible="dialogFormVisible"
        class-name="org-panel-more-search-dialog"
        @callback="search"
        @close="visible => dialogFormVisible = visible"
        @action-event="handleMoreSearchAction"
      /> -->
			</pcp-system-layout>
		</div>
	</div>
</template>
<script>
	import { partyTypeOptions, statusOptions, genderOptions } from './constants';
	import SelectorScope from './mixins/selectorScope';
	import NewPanelTree from './mixins/newPanelTree';
	import SelectionMixin from '@/p-components/pcp-selector-dialog/mixins/selection';
	import { query } from '@/api/position/index';
	import { getOrgList } from '@/api/userMange/index';
	import { queryWoutOrg } from '@/api/org/index';
	import { ActionUtils } from '@/utils/action';
	import { PcToolbar } from '@/components/pc-toolbar/index';
	import { PcCrud } from '@/components/pc-crud/index';
	import { PcpSystemLayout } from '@/p-components/pcp-system-layout/index';
	import { $utils } from '@/utils/publicUtils';

	export default {
		components: { PcpSystemLayout, PcCrud, PcToolbar },
		mixins: [SelectionMixin, SelectorScope, NewPanelTree],
		props: {
			formData: [Object, Array], // 所有字段数据,(包含主主子表)
			value: [Object, Array],
			multiple: Boolean,
			seetingSearchPartyType: String, // 设置查询用户类型
			height: {
				type: String,
				default: '400px',
			},
			partyTypeId: {
				// 类型节点ID
				type: [String, Number],
				default: '',
			},
			pkKey: {
				type: String,
				default: 'id',
			},
			partyTypeScope: String,
			currentOrgId: {
				// 当前用户组ID
				type: [String, Number],
				default: '',
			},
			// 外部用户id，上下级使用
			externalUseId: [String, Number],
			script: String,
			customPartyTypeOptions: {
				type: [Object, Array],
				default: () => {},
			},
			showTree: {
				// 是否显示左树
				type: Boolean,
				default: true,
			},
			isSuperInitTree: {
				// 是否为超管初始化树类型数据
				type: Object,
				default: () => {},
			},
			userRange: {
				type: Object,
				default: () => {},
			},
		},
		data() {
			return {
				width: 200,
				dialogFormVisible: false, // 弹窗
				editId: '',
				title: '更多查询条件',
				partyTypeOptions: $utils.isNotEmpty(this.customPartyTypeOptions)
					? this.customPartyTypeOptions
					: partyTypeOptions,
				statusOptions,
				genderOptions,
				partyType: $utils.isNotEmpty(this.customPartyTypeOptions) ? this.customPartyTypeOptions[0].value : 'org',
				// inclueChild: true,
				partyId: '',
				treeDatas: [],
				statusfixed: 'Q^STATUS_^S',
				// 树配置
				loadingTree: false,
				treeData: [],
				toolbars: [
					{
						key: 'refresh',
						label: '刷新',
					},
					{
						key: 'expand',
						label: '展开',
					},
					{
						key: 'compress',
						label: '收缩',
					},
				],
				// 列表配置
				loading: false,
				listData: [],
				loazTreeData: [],
				listConfig: {
					// 查询条件
					searchForm: {
						selector: true,
						forms: [
							{ prop: 'Q^FULL_NAME_^SL', label: '姓名', labelWidth: 50 },
							{ prop: 'Q^ACCOUNT_^SL', label: '账号', labelWidth: 50 },
						],
					},
					// 表格字段配置
					columns: [
						{ prop: 'name', label: '姓名', width: 150 },
						{ prop: 'account', label: '账号', width: 150 },
					],
				},
				pagination: { limit: 10 },
				sorts: {},
				moreSearchParams: {},
				lazyTree: true,
				defaultExpandedKeys: ['0'],
				defaultExpandAll: false,
				lazyOrgTree: true,
				partyTypeIdValue: '',
				currentOrgIdValue: '',
				scriptValue: '',
				scriptExecuteTime: false, // 脚本函数是否只执行一次
				hiddenTree: false, // 由于树形懒加载load函数的变换，需要重新渲染tree，load才能生效
				isExpand: true,
				responseDynamic: {}, // 动态脚本
				refresh: true,
			};
		},
		computed: {
			tableHeight() {
				const h = this.height.substr(0, this.height.length - 2);
				return parseInt(h);
			},
			changeParams() {
				const { partyTypeId, currentOrgId, isUseScope, script, partyTypeScope } = this;
				return {
					partyTypeId,
					currentOrgId,
					isUseScope,
					script,
					partyTypeScope,
				};
			},
			expandCollapseIcon() {
				return this.isExpand ? 'ExpandCollapseIcon' : 'UnExpandCollapseIcon';
			},
			treeWidth() {
				let width = 0;
				if (this.isExpand) {
					width = 200;
				} else {
					width = 10;
				}
				return width;
			},
			nodeWidth() {
				return (node) => {
					return this.width - 24 * node.level;
				};
			},
			stringWidth() {
				return (node) => {
					return this.getTextWidth(node.label);
				};
			},
		},
		watch: {
			options: {
				handler(val) {
					this.extraOptions = val || {};
				},
				immediate: true,
				deep: true,
			},
			showTree: {
				handler(val) {
					this.lazyTree = this.partyType === 'org';
					if (val === false) {
						this.listConfig.searchForm.forms = [
							{ prop: 'Q^NAME_^SL', label: '姓名', labelWidth: 50 },
							{ prop: 'Q^ACCOUNT_^SL', label: '账号', labelWidth: 50 },
							{ prop: 'Q^MOBILE_^SL', label: '手机号', labelWidth: 50 },
						];
						this.listConfig.columns = [
							{ prop: 'name', label: '姓名' },
							{ prop: 'account', label: '账号' },
							{ prop: 'mobile', label: '手机号', width: '150' },
							{ prop: 'orgName', label: '归属组织' },
						];
					} else {
						this.listConfig.searchForm.forms = [
							{ prop: 'name', label: '姓名' },
							{ prop: 'account', label: '账号' },
							{ prop: 'mobile', label: '手机号' },
						];
						this.listConfig.columns = [
							{ prop: 'name', label: '姓名' },
							{ prop: 'account', label: '账号' },
							{ prop: 'mobile', label: '手机号', width: '150' },
							{ prop: 'orgName', label: '归属组织' },
						];
					}
				},
				immediate: true,
			},
			changeParams: {
				handler(newval, oldval) {
					this.partyTypeIdValue = newval.partyTypeId;
					this.currentOrgIdValue = newval.currentOrgId;
					this.scriptValue = newval.script;
					// 普通模式与选择器范围模式切换调用
					let initDesignatedAType; // 机构和岗位懒加载时的特殊处理参数【类型为3时的切换】
					if (oldval === undefined) {
						initDesignatedAType = false;
					} else {
						if (
							(newval.partyTypeScope === 'org' || newval.partyTypeScope === 'position') &&
							newval.partyTypeId === '3'
						) {
							initDesignatedAType = false;
						} else {
							initDesignatedAType = true;
						}
					}
					newval.isUseScope ? this.loadTreeData(true, initDesignatedAType) : null;
				},
				deep: true,
				immediate: true,
			},
		},
		mounted() {
			if (this.showTree) {
				if (this.isUseScope) return;
				this.loadListData();
			} else {
				this.loadListData();
			}
		},
		beforeUnmount() {
			this.partyTypeOptions = null;
			this.statusOptions = null;
			this.genderOptions = null;
			this.treeDatas = null;
			this.treeData = null;
			this.toolbars = null;
			this.listData = null;
			this.loazTreeData = null;
			this.listConfig = null;
			this.pagination = null;
			this.sorts = null;
			this.moreSearchParams = null;
			this.defaultExpandedKeys = null;
			this.responseDynamic = null;
		},
		methods: {
			// 加载数据
			loadListData() {
				let type = this.partyType;
				this.loading = true;
				if (this.showTree) {
					// 显示树由右边树决定
					if ($utils.isNotEmpty(this.partyId) || this.isUseScope) {
						type = this.partyType;
					} else if (this.currentOrgIdValue && this.currentOrgIdValue !== '') {
						type = 'org';
					}
					query(type, this.getFormatParams())
						.then((response) => {
							this.loading = false;
							ActionUtils.handleListData(this, response);
							this.setSelectRow();
						})
						.catch(() => {
							this.loading = false;
						});
				} else if (this.seetingSearchPartyType === 'position') {
					getOrgList(this.getFormatParams())
						.then((response) => {
							this.loading = false;
							ActionUtils.handleListData(this, response);
							this.setSelectRow();
						})
						.catch(() => {
							this.loading = false;
						});
				} else if ($utils.isNotEmpty(this.currentOrgIdValue)) {
					queryWoutOrg(this.getFormatParams())
						.then((response) => {
							this.loading = false;
							ActionUtils.handleListData(this, response);
							this.setSelectRow();
						})
						.catch(() => {
							this.loading = false;
						});
				} else {
					getOrgList(this.getFormatParams())
						.then((response) => {
							this.loading = false;
							ActionUtils.handleListData(this, response);
							this.setSelectRow();
						})
						.catch(() => {
							this.loading = false;
						});
				}
			},
			// 获取查询条件格式化参数
			getFormatParams() {
				const params = this.$refs['crud'] ? this.$refs['crud'].getSearcFormData() : {};
				const extraOptions = this.extraOptions;
				const key =
					this.partyType === 'org'
						? 'orgId'
						: this.partyType === 'position'
						? 'positionId'
						: this.partyType === 'role'
						? 'roleId'
						: this.partyType === 'group'
						? 'groupId'
						: '';
				if (this.showTree) {
					if ($utils.isNotEmpty(this.partyId) || this.currentOrgIdValue !== '') {
						params[key] = this.partyId === '' ? this.currentOrgIdValue : this.partyId;
					} else {
						params[key] =
							this.partyTypeId === '1' || (this.partyTypeId === '5' && this.extraOptions.userid === '1')
								? ''
								: this.partyTypeId;
					}
					// 处理bug-9382 加上默认0
					if ($utils.isEmpty(params[key])) {
						params[key] = '0';
					}
				}
				if (this.partyTypeId === '5') {
					params['inclueChild'] = true;
				}
				// 岗位选择器
				if (this.seetingSearchPartyType === 'position') {
					params['positionId'] = this.partyTypeId;
				}
				if (this.moreSearchParams) {
					Object.assign(params, this.moreSearchParams);
				}
				if ($utils.isNotEmpty(extraOptions) && extraOptions.optionsType === 'listParams') {
					extraOptions.params ? (params[extraOptions.params.key] = extraOptions.params.value) : null;
				}
				if (this.statusfixed === 'Q^STATUS_^S') {
					params['Q^STATUS_^S'] = 'actived';
				}
				params['type'] = this.userRange?.userRange || '';
				params['depIds'] = this.userRange?.userDepRange?.map((item) => item.id).join(',') || '';
				return ActionUtils.formatParams(params, this.pagination, this.sorts);
			},
			// 处理分页事件
			handlePaginationChange(page) {
				this.changePageCoreRecordData();
				ActionUtils.setPagination(this.pagination, page);
				this.loadListData();
			},
			// 处理排序
			handleSortChange(sort) {
				ActionUtils.setSorts(this.sorts, sort);
				this.loadListData();
			},
			// 查询
			search() {
				this.loadListData();
			},
			// 重置查询
			resetSearch() {
				this.$refs.crud ? this.$refs.crud.resetSearch() : null;
				ActionUtils.setFirstPagination(this.pagination);
				this.search();
			},
			// 处理更多按钮事件
			handleAction(command) {
				// command, position, selection, data
				switch (command) {
					case 'search': // 查询
						ActionUtils.setFirstPagination(this.pagination);
						this.search();
						break;
					case 'resetSearch': // 重置查询
						this.resetSearch();
						break;
					case 'moreSearch': // 更多
						this.handleMoreSearch();
						break;
					default:
						break;
				}
			},
			// 处理按钮事件
			handleMoreSearchAction(data) {
				ActionUtils.setFirstPagination(this.pagination);
				this.moreSearchParams = data;
				this.loadListData();
			},
			// 处理更多
			handleMoreSearch() {
				this.dialogFormVisible = true;
			},
			changePartyType(value) {
				this.loadingTree = true;
				if (this.isUseScope) {
					this.hiddenTree = true;
				}
				this.partyType = value;
				const ref = this.$refs.elTree;
				const { loadPosTreeNode, loadPosTreeNode3, loadOrgTreeNode3, loadOrgTreeNode } = this;
				ref.store.load =
					value === 'position'
						? this.partyTypeId === '3'
							? loadPosTreeNode3
							: loadPosTreeNode
						: value === 'org'
						? this.partyTypeId === '3'
							? loadOrgTreeNode3
							: loadOrgTreeNode
						: null;
				// 选择器范围模式函数回调
				this.moreSearchParams = {};
				// 普通模式与选择器范围模式切换调用
				!this.isUseScope ? this.loadTreeData() : null;
				this.scriptExecuteTime = false; // 初始化脚本类型时的函数调用
				this.$emit('change-party-type', value);
			},
			getChildrenIds(data, list) {
				list.push(data.id);
				const children = data.children;
				if ($utils.isNotEmpty(children)) {
					for (let i = 0; i < children.length; i++) {
						const element = children[i];
						this.getChildrenIds(element, list);
					}
				}
				return list;
			},
			getSearcFormData() {
				const params = {};
				if (!this.$refs.searchForm) {
					return params;
				}
				this.$refs.searchForm.getParams((error, formParams) => {
					if (!error) {
						return Object.assign(params, formParams);
					}
				});
				return params;
			},
			handleExpandCollapse() {
				this.isExpand = !this.isExpand;
			},
			// 获取字符串长度
			getTextWidth(str) {
				const dom = document.createElement('span');
				dom.style.display = 'inline-block';
				dom.textContent = str;
				document.body.appendChild(dom);
				const width = dom.offsetWidth;
				document.body.removeChild(dom);
				return width;
			},
		},
	};
</script>
<style lang="scss" scoped>
	$border-color: #e5e6e7;

	.employee-container {
		.platform-layout__body {
			overflow: hidden;
		}
	}

	.pc-employee-selector-tree {
		position: relative;
		border-right: 1px solid #e7eaef;
		margin-right: 16px;
		height: 96%;

		.layout-header-tools {
			width: 26px;
			height: 31px;
			top: 15px;
			right: 0px;
			z-index: 99;
			position: absolute;
			padding: 0;

			.pin-btn {
				cursor: pointer;
				line-height: 28px;
				color: #c4c4c4;
				font-size: 16px;
				margin-left: 10px;

				svg {
					path:nth-of-type(1) {
						fill: #ffffff;
					}
				}
			}
		}

		.pc-tree-toolbar {
			position: absolute;
			top: 0px;
			right: 0px;
			height: 30px;
			padding: 5px;

			.el-button {
				background: #fff;
				min-width: 30px;
			}
		}

		.pc-tree-search-form {
			width: 130px;
			padding: 5px;

			:deep(.el-select .el-input__wrapper) {
				background: #fff;
			}
		}

		.pc-tree-wrapper {
			padding-right: 15px;

			.el-tree > .el-tree-node {
				display: inline-block;
				width: 100%;
			}
		}
	}
</style>
